var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ui-tabbar-wrapper", attrs: { "data-v-a6a2afe4": "" } },
    [
      _c(
        "div",
        { staticClass: "tabbar-wrapper", attrs: { "data-v-a6a2afe4": "" } },
        [
          _c(
            "ul",
            { attrs: { "data-v-a6a2afe4": "" } },
            _vm._l(_vm.staticData, function (item) {
              return _c(
                "li",
                {
                  key: item.key,
                  staticClass: "item",
                  class: { currentavtive: _vm.currentItem == item.link },
                  attrs: { "data-v-a6a2afe4": "" },
                  on: {
                    click: function ($event) {
                      _vm.setCurrentActive(item)
                    },
                  },
                },
                [
                  _vm.currentItem != item.link
                    ? _c("img", {
                        attrs: { "data-v-a6a2afe4": "", src: item.bgurl },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentItem == item.link
                    ? _c("img", {
                        attrs: { "data-v-a6a2afe4": "", src: item.activeBgurl },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.cartNumber > 0 && item.link == "cart" && _vm.isOnline
                    ? _c("span", { attrs: { "data-v-a6a2afe4": "" } }, [
                        _vm._v(_vm._s(_vm.getCarCount)),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  item.name == _vm.$t("tabBar.t4") && _vm.isHasUnreadCount
                    ? _c("p", { attrs: { "data-v-a6a2afe4": "" } })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("a", { attrs: { "data-v-a6a2afe4": "" } }, [
                    _vm._v(_vm._s(item.name)),
                  ]),
                ]
              )
            })
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }